import React from "react";
import { Link } from "react-router-dom";
function TeamMembers() {
  return (
    <div>
      <section className="lawyers-team-section style-two bg-secondary">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-9 col-md-8 col-lg-7 col-xl-6">
              <div className="section-heading text-center">
                <div className="sub-title justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Our Team
                </div>
                <h2>Exceptional Legal Team for Your Success</h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center g-4">
            {/* Laywer Card */}
            <div className="col-12 col-sm-6 col-lg-4">
              <div className="laywer-card bg-white">
                <img src="assets/img/bg-img/44.jpg" alt="" />

                {/* Laywer Info */}
                <div className="laywer-info text-center">
                  <div className="laywer-name">Shawn S. Kerendian</div>
                  <div className="laywer-position">Associate Director</div>
                </div>

                {/* Hover: Laywer Info */}
                <div className="hover-laywer-info text-center">
                  <div className="laywer-name">Shawn S. Kerendian</div>
                  <div className="laywer-position">Associate Director</div>
                  {/* Social Nav */}
                  <div className="social-nav">
                    <Link to="#">
                      <i className="ti ti-brand-facebook"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-x"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-linkedin"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-instagram"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Laywer Card */}
            <div className="col-12 col-sm-6 col-lg-4">
              <div className="laywer-card bg-white">
                <img src="assets/img/bg-img/45.jpg" alt="" />

                {/* Laywer Info */}
                <div className="laywer-info text-center">
                  <div className="laywer-name">Joseph Thomas</div>
                  <div className="laywer-position">Financial lawyer</div>
                </div>

                {/* Hover: Laywer Info */}
                <div className="hover-laywer-info text-center">
                  <div className="laywer-name">Joseph Thomas</div>
                  <div className="laywer-position">Financial lawyer</div>
                  {/* Social Nav */}
                  <div className="social-nav">
                    <Link to="#">
                      <i className="ti ti-brand-facebook"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-x"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-linkedin"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-instagram"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Laywer Card */}
            <div className="col-12 col-sm-6 col-lg-4">
              <div className="laywer-card bg-white">
                <img src="assets/img/bg-img/46.jpg" alt="" />

                {/* Laywer Info */}
                <div className="laywer-info text-center">
                  <div className="laywer-name">Daniyel Karlos</div>
                  <div className="laywer-position">Associate Director</div>
                </div>

                {/* Hover: Laywer Info */}
                <div className="hover-laywer-info text-center">
                  <div className="laywer-name">Daniyel Karlos</div>
                  <div className="laywer-position">Associate Director</div>
                  {/* Social Nav */}
                  <div className="social-nav">
                    <Link to="#">
                      <i className="ti ti-brand-facebook"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-x"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-linkedin"></i>
                    </Link>
                    <Link to="#">
                      <i className="ti ti-brand-instagram"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default TeamMembers;
